import { intervalToDuration } from 'date-fns';
import { FormattedDuration } from '../../types/FormattedDuration';

/**
 * Function for obtaining an object containing duration
 * @param time - the duration in milliseconds
 * @returns object FormattedDuration
 */
export const getFormattedDurationObject = (time: number): FormattedDuration | null => {
  if (time <= 0) return null;
  const duration = intervalToDuration({ start: 0, end: time });

  const formattedDuration = {
    hours: duration.hours ?? 0,
    minutes: duration.minutes ?? 0,
    seconds: duration.seconds ?? 0,
  };
  return formattedDuration;
};
